export default __webpack_public_path__ + "static/media/attractions3.8575b552.avif";